export const JOBS_ANALYTICS_EVENTS = {
  jobPostCreated: "jobs job post created",
  jobPostUpdated: "jobs job post updated",
  jobPostPublished: "jobs job post published",
  jobPostUnpublished: "jobs job post unpublished",
  jobPostHidden: "jobs job post hidden",
  jobPostRevertedToDraft: "jobs job post reverted to draft",
  jobPostClosed: "jobs job post closed",
  jobPostDeleted: "jobs job post deleted",
  jobPostRenewed: "jobs job post renewed",
  jobPostSentForReview: "jobs job post sent for review",
  applicantReviewSlackRequested: "jobs applicant review slack requested",
  listFiltered: "jobs list filtered",
  applicationCreated: "jobs application created",
  applicationDeleted: "jobs application deleted",
  applicationReviewCreated: "jobs application review created",
  applicationReviewUpdated: "jobs application review updated",
  applicationReviewDeleted: "jobs application review deleted",
  applicationFilesUpdated: "jobs application files updated",
  applicationsListFiltered: "jobs applications list filtered"
} as const;

export type JobsAnalyticsSource =
  | "jobs_create"
  | "jobs_edit"
  | "jobs_publish"
  | "jobs_unpublish"
  | "jobs_hide"
  | "jobs_revert_draft"
  | "jobs_close"
  | "jobs_delete"
  | "jobs_renew"
  | "jobs_send_review"
  | "jobs_slack_review_request"
  | "jobs_all"
  | "jobs_my"
  | "jobs_execusearch"
  | "jobs_facility"
  | "jobs_person"
  | "jobs_section"
  | "jobs_list"
  | "jobs_application_create"
  | "jobs_application_delete"
  | "jobs_application_review_create"
  | "jobs_application_review_update"
  | "jobs_application_review_delete"
  | "jobs_application_files_update"
  | "jobs_applications"
  | "jobs_application_reviews";

export type JobsAnalyticsData = {
  source: JobsAnalyticsSource;
  success: boolean;
  jobPostId?: string;
  jobApplicationId?: string;
  action?: string;
  isDraft?: boolean;
  sentForReview?: boolean;
  stage?: string;
  isAdminPublish?: boolean;
  status?: string;
  reviewerCount?: number;
  isRecommendation?: boolean;
  score?: number;
  hasResume?: boolean;
  hasCoverLetter?: boolean;
};

export type JobsListFilterValue = string | boolean | undefined;

export type JobsApplicationsListFilterValue = string | boolean | undefined;

export function getJobsListAnalyticsSource(pathname: string): JobsAnalyticsSource {
  if (pathname.includes("/facilities/")) return "jobs_facility";
  if (pathname.includes("/people/")) return "jobs_person";
  if (pathname.includes("/sections/")) return "jobs_section";
  if (pathname.includes("/execusearch")) return "jobs_execusearch";
  if (pathname.includes("/my-jobs")) return "jobs_my";
  if (pathname.includes("/all-jobs")) return "jobs_all";
  return "jobs_list";
}

export function getJobsListFilterAnalyticsData({
  source,
  filter,
  value
}: {
  source: JobsAnalyticsSource;
  filter: string;
  value: JobsListFilterValue;
}) {
  return {
    source,
    filter,
    value
  };
}

export function getJobsApplicationsListFilterAnalyticsData({
  source,
  filter,
  value
}: {
  source: Extract<JobsAnalyticsSource, "jobs_applications" | "jobs_application_reviews">;
  filter: string;
  value: JobsApplicationsListFilterValue;
}) {
  return {
    source,
    filter,
    value
  };
}

export function getJobsAnalyticsData({
  source,
  success = true,
  ...rest
}: {
  source: JobsAnalyticsSource;
  success?: boolean;
} & Omit<JobsAnalyticsData, "source" | "success">): JobsAnalyticsData {
  return {
    source,
    success,
    ...Object.fromEntries(Object.entries(rest).filter(([, value]) => value !== undefined && value !== null))
  };
}
